import { Bookmark, ExplorerBookmarkState } from "@novorender/data-js-api";

import { PublicIdMap } from "./misc";

export type LegacyBookmark = Bookmark & { version?: undefined; explorerState: undefined };
export type V1Bookmark = Bookmark & { version?: undefined; explorerState: ExplorerBookmarkState };
export type V2Bookmark = Bookmark & {
    version: 2;
    publicIdMap: PublicIdMap;
    explorerState: ExplorerBookmarkState;
};
export type VersionedBookmark = V1Bookmark | V2Bookmark;

export function isLegacyBookmark(bm: Bookmark): bm is LegacyBookmark {
    return !bm.explorerState;
}

export function isV1Bookmark(bm: Bookmark): bm is V1Bookmark {
    return bm.version === undefined && bm.explorerState !== undefined;
}

export function isV2Bookmark(bm: Bookmark): bm is V2Bookmark {
    return bm.version === 2;
}

export function isVersionedBookmark(bm: Bookmark): bm is VersionedBookmark {
    return !isLegacyBookmark(bm);
}
